import { useState } from "react";
import { CalendarPlus } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const meetingStart = (c) => {
  if (c.start_at) return new Date(c.start_at);
  if (c.scheduled_at && c.scheduled_time) return new Date(`${c.scheduled_at}T${c.scheduled_time}`);
  return null;
};

const stamp = (d) => d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
const esc = (s) => (s || "").replace(/[\\,;]/g, (m) => `\\${m}`).replace(/\n/g, "\\n");

export const CalendarButton = ({ c }) => {
  const [open, setOpen] = useState(false);
  const start = meetingStart(c);
  if (!start || isNaN(start)) return null;
  const end = new Date(start.getTime() + (Number(c.duration) || 60) * 60000);
  const link = `${window.location.origin}/conference/${c.id}`;
  const details = `${c.description ? `${c.description}\n\n` : ""}Join: ${link}\nRoom code: ${c.room_code || ""}`;
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(c.title)}&dates=${stamp(start)}/${stamp(end)}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(link)}`;
  const outlook = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(c.title)}&startdt=${start.toISOString()}&enddt=${end.toISOString()}&body=${encodeURIComponent(details)}&location=${encodeURIComponent(link)}`;
  const ics = () => {
    const body = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//ShopAdvisor//Meetings//EN", "BEGIN:VEVENT", `UID:${c.id}@theshopadvisor.com`, `DTSTAMP:${stamp(new Date())}`,
      `DTSTART:${stamp(start)}`, `DTEND:${stamp(end)}`, `SUMMARY:${esc(c.title)}`, `DESCRIPTION:${esc(details)}`, `LOCATION:${esc(link)}`, `URL:${link}`,
      "BEGIN:VALARM", "TRIGGER:-PT15M", "ACTION:DISPLAY", "DESCRIPTION:Meeting starts in 15 minutes", "END:VALARM", "END:VEVENT", "END:VCALENDAR"].join("\r\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([body], { type: "text/calendar" }));
    a.download = `${c.title.replace(/[^\w-]+/g, "-").slice(0, 60) || "meeting"}.ics`;
    a.click();
  };
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button className="px-3 py-2 rounded-lg text-sm font-semibold flex items-center gap-1 border border-slate-300 text-slate-700 hover:bg-slate-50" data-testid={`add-calendar-${c.id}`}><CalendarPlus className="w-4 h-4" />Add to calendar</button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white">
        <DropdownMenuItem asChild><a href={google} target="_blank" rel="noreferrer" data-testid={`calendar-google-${c.id}`}>Google Calendar</a></DropdownMenuItem>
        <DropdownMenuItem onSelect={ics} data-testid={`calendar-ics-${c.id}`}>Apple / iPhone (.ics)</DropdownMenuItem>
        <DropdownMenuItem asChild><a href={outlook} target="_blank" rel="noreferrer" data-testid={`calendar-outlook-${c.id}`}>Outlook</a></DropdownMenuItem>
        <DropdownMenuItem onSelect={ics} data-testid={`calendar-ics2-${c.id}`}>Other (.ics file)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
